const actionConstants = {
    SHOW_CAMERA: "SHOW_CAMERA",
    HIDE_CAMERA: "HIDE_CAMERA",
    SHOW_RECORDER: "SHOW_RECORDER",
    HIDE_RECORDER: "HIDE_RECORDER",
    NEXT_QUESTION: "NEXT_QUESTION",
    PREVIOUS_QUESTION: "PREVIOUS_QUESTION",
    CAN_ADVANCE: "CAN_ADVANCE",
    ASSIGN_FROM_CAMERA: "ASSIGN_FROM_CAMERA",
    ASSIGN_FROM_CAMERA_NEW: "ASSIGN_FROM_CAMERA_NEW",
    ASSIGN_VALUE: "ASSIGN_VALUE",
    START_LOADING: "START_LOADING",
    STOP_LOADING: "STOP_LOADING",
    SHOW_DIALOG: "SHOW_DIALOG",
    HIDE_DIALOG: "HIDE_DIALOG",
    UPDATE_FILE_UPLOAD_PROGRESS: "UPDATE_FILE_UPLOAD_PROGRESS",
    UPDATE_QUESTION_RETRIES: "UPDATE_QUESTION_RETRIES",
    CREATE_SVR_RECORD: "CREATE_SVR_RECORD",
    SAVE_RECORD: "SAVE_RECORD",
    SAVE_FILEPATH: "SAVE_FILEPATH",
    INCREMENT_FILE_UPLOAD_COUNTER: "INCREMENT_FILE_UPLOAD_COUNTER",
    DECREMENT_FILE_UPLOAD_COUNTER: "DECREMENT_FILE_UPLOAD_COUNTER",
    INCREMENT_BACKGROUND_REQUEST_COUNTER: "INCREMENT_BACKGROUND_REQUEST_COUNTER",
    DECREMENT_BACKGROUND_REQUEST_COUNTER: "DECREMENT_BACKGROUND_REQUEST_COUNTER",
    DISPLAY_USER_MESSAGE: "DISPLAY_USER_MESSAGE",
    HIDE_USER_MESSAGE: "HIDE_USER_MESSAGE",
    LOAD_QUESTION_SET: "LOAD_QUESTION_SET",
    INITIALIZE_QUESTION_SET: "INITIALIZE_QUESTION_SET",
    INITIATE_WORKFLOW_SESSION: "INITIATE_WORKFLOW_SESSION",
    UPDATE_COMPANION_WORKFLOW_SESSION_ID: "UPDATE_COMPANION_WORKFLOW_SESSION_ID",
    RESUME_WORKFLOW_SESSION: "RESUME_WORKFLOW_SESSION",
    HIDE_RESUME_WORKFLOW_MSG: "HIDE_RESUME_WORKFLOW_MSG",
    MARK_MEDIA_AS_TAMPERED: "MARK_MEDIA_AS_TAMPERED",
    LOAD_CLIENT_REQUEST: "LOAD_CLIENT_REQUEST",
    LOAD_WORKFLOW_DATA: "LOAD_WORKFLOW_DATA",
    LOAD_UI_CONFIG: "LOAD_UI_CONFIG",
    CAPTURE_REF_ID: "CAPTURE_REF_ID",
    CAPTURE_REQUEST_ID: "CAPTURE_REQUEST_ID",
    CAPTURE_ACCESS_CODE: "CAPTURE_ACCESS_CODE",
    CAPTURE_ORGANIZATION: "CAPTURE_ORGANIZATION",
    CAPTURE_USERDATA: "CAPTURE_USERDATA",
    SAVE_LOCATION: "SAVE_LOCATION",
    VALUE_FORMAT_ERROR: "VALUE_FORMAT_ERROR",
    MERGE_ADDITIONAL_QUESTIONS: "MERGE_ADDITIONAL_QUESTIONS",
    STORE_ANALYSIS_RESPONSE: "STORE_ANALYSIS_RESPONSE",
    RECORD_BILLABLE_OPERATION: "RECORD_BILLABLE_OPERATION",
    UPLOAD_ANSWER_DATA: "UPLOAD_ANSWER_DATA",
    ADD_BACKGROUND_MEDIA_FUNCS: "ADD_BACKGROUND_MEDIA_FUNCS",
    REMOVE_BACKGROUND_MEDIA_FUNCS: "REMOVE_BACKGROUND_MEDIA_FUNCS",
    STORE_EXTRACTED_RESULT: "STORE_EXTRACTED_RESULT",
    STORE_RESULT_DATA: "STORE_RESULT_DATA",
    STORE_MEDIA_FILE_DATA: "STORE_MEDIA_FILE_DATA",
    SUBMITTED_WORKFLOW: "SUBMITTED_WORKFLOW",
    APPEND_MEDIA_FILE_DATA: "APPEND_MEDIA_FILE_DATA",
    VALIDATE_FIELD: "VALIDATE_FIELD"
};

export default actionConstants;
